import React from "react";
import ReactDOM from "react-dom/client";

import { AppRouter } from "@client/app/router";
import "@client/styles/base.css";
import "@client/styles/responsive.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Missing #root application element");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
);
